import FirstFunding from '../../../../banking/components/account-opening/first-funding/FirstFunding';

const FirstFundingScreen = () => <FirstFunding />;

export default FirstFundingScreen;
